import { SUB_MENU_ITEM_PARENT_KEY } from '../SubMenu.constants'

export function isSubMenuNestedItem(item) {
  return Boolean(item[SUB_MENU_ITEM_PARENT_KEY])
}
